export default {
  title: 'Документы'
}
